import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  TableHead,
  Table,
  Button,
  FormControl,
  TextField,
  IconButton,
  Select,
  MenuItem,
  Autocomplete,
  Checkbox,
  Popper,
  Skeleton,
  Modal,
  FormHelperText,
  Divider,
  Chip,
  Stack,
  InputLabel,
  Paper,
} from "@mui/material";
import {
  headingStyle,
  tableCellLab,
  tableRowLab,
  xBtn,
} from "../../style/LapPageStyle";
import CloseIcon from "@mui/icons-material/Close";
import {
  menuItemStyle,
  primaryBtn,
  selectField,
  textfieldText,
  textfieldTextBlueBorderPharmacy,
} from "../../style/AppointmentStyle";
import AddIcon from "@mui/icons-material/Add";
import { Edit } from "@mui/icons-material";
import CustomModal from "../CustomModal/CustomModal";
import EditMedicineBatchShort from "./EditMedicineBatchShort";
import {
  getPriceByQuantity,
  getPriceByQuantityForReturn,
  reprintInvoice,
  refundInvoice,
  getMedicineByName,
} from "../../connections/getApi";
import UseGetMedicineDetail from "../../helper/UseGetMedicineDetail";
import UseGetInvoice from "../../helper/UseGetInvoice";
import { useReactToPrint } from "react-to-print";
import PharmacyInvoice from "../PrintCompoents/PharmacyInvoice";
import { showToast } from "../../utils/toastUtil";
import UseGetAllMedicineList from "../../helper/UseGetAllMedicineList";
import UseFetchGetOrganizationDetails from "../../helper/UseFetchGetOrganizationDetails";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import {
  orangeButton,
  primaryBtnTeal,
  textfieldTextPrep,
} from "../../style/PatientDetailsStyle";
import { drTableGreen, drTableRowBlueBg } from "../../style/PatinetFormStyle";
import { pharmacyUpdateBill } from "../../connections/putApi";
import { autoFocusOffWithOutBorder } from "../../style/PatinetFormStyle";
import {
  expiryMedicineFormate,
  formattedDateWithoutBg,
  isExpiredDate,
  roundToNearestUnit,
} from "../../utils/constantFunctions";
import dayjs from "dayjs";
import { editPharmacyPatient } from "../../connections/putApi";

const PastBillPharmacyByInvoice = ({
  id,
  uid,
  onClose,
  setOpenBillByInvoice,
  refetch,
  showBtn,
}) => {
  const [formState, setFormState] = useState({
    full_name: "",
    uid: "",
    mobile: "",
    email: "",
    dob: "",
    gender: "",
    patient_id: "",
    prescription_id: null,
    invoice_id: "",
  });
  const [medicines, setMedicines] = useState([
    {
      id: "",
      name: "",
      quantity: "",
      batchId: null,
      batch: "",
      batchArray: [],
      returned: false,
      stock: "",
      packing: "",
      unitMrp: null,
      mrp: null,
      discount: null,
      gst: null,
      amount: null,
    },
  ]);
  const [medicineToTrackDestroy, storeMedicineToTrackDestroy] = useState([]);
  const [total, setTotal] = useState(0);
  const [billSummary, setBillSummary] = useState({
    taxableTotal: 0,
    totalGst: 0,
    discount: 0,
    netPayable: 0,
  });

  const [select, setSelect] = useState(null);
  const [selectedMedicine, setSelectedMedicine] = useState(null);
  const [showButton, setShowButton] = useState(true);
  const [printInvoiceData, setPrintInvoiceData] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredMedicines, setFilteredMedicines] = useState([]);
  const [openMedicineList, setOpenMedicines] = useState(false);
  const [highlightedIndexMedicine, setHighlightedIndexMedicine] = useState(0);
  const [isButtonDisable, setIsButtonDisable] = useState(false);
  const [isFormChanged, setIsFormChanged] = useState(false);
  const [invoicePaymentsAttributes, setInvoicePaymentsAttributes] = useState([
    { id: null, amount: "", payment_mode: "UPI" },
  ]);
  const paymentModes = [
    { label: "UPI", value: "UPI" },
    { label: "Cash", value: "Cash" },
    { label: "Card", value: "Card" },
    { label: "Cheque", value: "Cheque" },
  ];

  const [specialDiscountPct, setSpecialDiscountPct] = useState("");
  const [specialDiscountINR, setSpecialDiscountINR] = useState("");
  const specialDiscountPctRef = useRef("");

  const [isPriceFetching, setIsPriceFetching] = useState(false);
  const priceRequestControllers = useRef(new Map());
  const pendingPriceCount = useRef(0);

  const getAvailablePaymentModes = (currentIndex) => {
    const selectedModes = invoicePaymentsAttributes
      .map((item, index) => (index !== currentIndex ? item.payment_mode : null))
      .filter(Boolean);

    return paymentModes.filter((mode) => !selectedModes.includes(mode.value));
  };

  const getRawTotal = () =>
    medicines.reduce((sum, m) => {
      if (m.name && m.quantity > 0 && m.id)
        return sum + Math.abs(parseFloat(m.unitMrp) || 0) * Math.abs(parseFloat(m.quantity) || 0);
      return sum;
    }, 0);

  const handleSpecialDiscountPct = (val) => {
    setSpecialDiscountPct(val);
    const pct = parseFloat(val);
    if (!val || isNaN(pct)) { setSpecialDiscountINR(""); return; }
    setSpecialDiscountINR((getRawTotal() * pct / 100).toFixed(2));
  };

  const handleSpecialDiscountINR = (val) => {
    setSpecialDiscountINR(val);
    const inr = parseFloat(val);
    const raw = getRawTotal();
    if (!val || isNaN(inr) || raw === 0) { setSpecialDiscountPct(""); return; }
    setSpecialDiscountPct(((inr / raw) * 100).toFixed(2));
  };

  const { data: invoiceDetails, isLoading } = UseGetInvoice(id);
  const roundOff = invoiceDetails?.config_round_off ?? null;
  const { data: medicineList } = UseGetAllMedicineList();

  const { data: orgData } = UseFetchGetOrganizationDetails();
  const orgFeatures =
    orgData?.payload?.organization_features ||
    orgData?.organization_features ||
    [];
  const allowBatchStockZero = orgFeatures.find(
    (f) => f?.key === "allow_batch_stock_zero" && f?.active === true,
  );
  const { data: medicineDetail } = UseGetMedicineDetail(selectedMedicine?.id);

  // const { patientData } = useSelector((state) => state.pharmacy);
  // const { patientDetailsData } = useSelector((state) => state.pharmacy);

  const [errors, setErrors] = useState({});
  useEffect(() => {
    // Simulating fetching all data on component mount and storing it in local storage or state.
    if (
      medicineList?.payload?.medicines &&
      medicineList?.payload?.medicines?.length > 0
    ) {
      localStorage.setItem(
        "allMedicines",
        JSON.stringify(medicineList?.payload?.medicines),
      );
    }
  }, [medicineList]);

  // add at top of component:
  const paymentsHydratedRef = useRef(false);

  useEffect(() => {
    if (invoiceDetails) {
      setFormState({
        full_name: invoiceDetails.patient_info?.name || "",
        uid: invoiceDetails.patient_info?.uid || "",
        mobile: invoiceDetails.patient_info?.mobile || "",
        dob: invoiceDetails.patient_info?.dob || "",
        email: invoiceDetails.patient_info?.email || "",
        gender: invoiceDetails.patient_info?.gender || "",
        age:
          invoiceDetails.patient_info?.age >= 0
            ? invoiceDetails.patient_info?.age
            : "",
        patient_id: invoiceDetails?.patient_id || "",
        prescription_id: invoiceDetails?.prescription_id || null,
        invoice_id: invoiceDetails?.id || "",
      });

      // setMedicines(
      //   invoiceDetails?.medicines?.map((medicine) => {
      //     const matchedInvoiceItem = invoiceDetails?.invoice_items?.find(
      //       (item) => item.invoice_itemable_id === medicine.id,
      //     );

      //     return {
      //       id: medicine?.id,
      //       name: medicine?.name || "",
      //       batchId: medicine?.batch || null,
      //       batch:
      //         medicine?.medicine_batches?.find(
      //           (batch) => batch?.id === medicine?.batch,
      //         ) || null,
      //       batchArray: medicine?.medicine_batches || [],
      //       stock: medicine?.stock_left,
      //       packing:
      //         (medicine?.medicine_batches?.length > 0 &&
      //           medicine?.medicine_batches[0]?.packing) ||
      //         "",
      //       unitMrp: medicine?.returned
      //         ? -medicine.unit_price
      //         : medicine.unit_price,
      //       mrp: medicine?.returned ? -medicine.mrp : medicine.mrp,
      //       discount: `-${medicine?.discount || 0}%`,
      //       gst: medicine?.gst || 0,
      //       amount: medicine?.returned
      //         ? -(medicine?.grand_total || 0)
      //         : medicine?.grand_total || 0,
      //       expiry_date: medicine?.medicine_batches[0]?.expiry_date,
      //       quantity: medicine?.quantity || 1,
      //       returned: medicine?.returned,
      //       invoice_id: matchedInvoiceItem?.id || null, // <-- This line adds invoice_id
      //     };
      //   }),
      // );

      // setMedicines(
      //   invoiceDetails?.medicines?.map((medicine) => {
      //     const matchedInvoiceItem = invoiceDetails?.invoice_items?.find(
      //       (item) => item.invoice_itemable_id === medicine.id,
      //     );

      //     const amount = Number(matchedInvoiceItem?.amount || 0);
      //     const costPerUnit = Number(matchedInvoiceItem?.cost_per_unit || 0);
      //     const discount = Number(matchedInvoiceItem?.discount || 0);
      //     const mrp = Number(matchedInvoiceItem?.mrp || 0);

      //     return {
      //       id: medicine?.id,
      //       name: medicine?.name || "",
      //       batchId: medicine?.batch || null,
      //       batch:
      //         medicine?.medicine_batches?.find(
      //           (batch) => batch?.id === medicine?.batch,
      //         ) || null,
      //       batchArray: medicine?.medicine_batches || [],
      //       stock: medicine?.stock_left,
      //       packing:
      //         matchedInvoiceItem?.packing ||
      //         medicine?.medicine_batches?.find(
      //           (batch) => batch?.id === medicine?.batch,
      //         )?.packing ||
      //         "",
      //       unitMrp: medicine?.returned ? -costPerUnit : costPerUnit,
      //       mrp: medicine?.returned ? -mrp : mrp,
      //       discount: `-${discount}`,
      //       gst: medicine?.gst || 0,
      //       amount: medicine?.returned ? -amount : amount,
      //       expiry_date:
      //         matchedInvoiceItem?.expiry_date ||
      //         medicine?.medicine_batches?.find(
      //           (batch) => batch?.id === medicine?.batch,
      //         )?.expiry_date,
      //       quantity: Number(
      //         matchedInvoiceItem?.quantity || medicine?.quantity || 1,
      //       ),
      //       returned: medicine?.returned,
      //       invoice_id: matchedInvoiceItem?.id || null,
      //     };
      //   }),
      // );

      setMedicines(
        invoiceDetails?.invoice_items?.map((invoiceItem) => {
          const medicine = invoiceDetails?.medicines?.find(
            (m) => m.id === invoiceItem.invoice_itemable_id,
          );

          const amount = Number(
            invoiceItem?.amount ?? medicine?.grand_total ?? 0,
          );
          const costPerUnit = Number(
            invoiceItem?.cost_per_unit ?? medicine?.unit_price ?? 0,
          );
          const discountPct = costPerUnit > 0
            ? (Number(invoiceItem?.discount_per_unit || 0) / costPerUnit) * 100
            : Number(medicine?.discount ?? 0);
          const mrp = Number(invoiceItem?.mrp ?? medicine?.mrp ?? 0);

          return {
            id: medicine?.id,
            name: medicine?.name || invoiceItem?.name || "",
            batchId: medicine?.batch || null,
            batch:
              medicine?.medicine_batches?.find(
                (batch) => batch?.id === medicine?.batch,
              ) || null,
            batchArray: medicine?.medicine_batches || [],
            stock: medicine?.stock_left,
            packing:
              invoiceItem?.packing ||
              medicine?.medicine_batches?.find(
                (batch) => batch?.id === medicine?.batch,
              )?.packing ||
              "",
            unitMrp: costPerUnit,
            mrp: mrp,
            discount: `${discountPct.toFixed(2)}%`,
            gst: medicine?.medicine_batches?.find((b) => b.id === medicine?.batch)?.gst ?? 0,
            amount: amount,
            expiry_date:
              invoiceItem?.expiry_date ||
              medicine?.medicine_batches?.find(
                (batch) => batch?.id === medicine?.batch,
              )?.expiry_date,
            quantity: Number(invoiceItem?.quantity || medicine?.quantity || 1),
            returned: medicine?.returned,
            invoice_id: invoiceItem?.id || null,
          };
        }),
      );
      // Detect special discount: if any item's applied % ≠ its catalog discount %
      const items = invoiceDetails?.invoice_items || [];
      const medicines_ = invoiceDetails?.medicines || [];
      let detectedSpecialPct = null;
      for (const item of items) {
        const cpu = Math.abs(Number(item?.cost_per_unit || 0));
        if (cpu <= 0) continue;
        const appliedPct = (Math.abs(Number(item?.discount_per_unit || 0)) / cpu) * 100;
        const medicine_ = medicines_.find((m) => m.id === item.invoice_itemable_id);
        const catalogPct = Number(medicine_?.discount || 0);
        if (Math.round(appliedPct * 100) !== Math.round(catalogPct * 100)) {
          detectedSpecialPct = appliedPct;
          break;
        }
      }
      if (detectedSpecialPct !== null && detectedSpecialPct > 0) {
        const rawTotal = items.reduce(
          (sum, item) =>
            sum + Math.abs(Number(item?.cost_per_unit || 0)) * Math.abs(Number(item?.quantity || 0)),
          0,
        );
        const totalDiscountINR = items.reduce(
          (sum, item) =>
            sum + Math.abs(Number(item?.discount_per_unit || 0)) * Math.abs(Number(item?.quantity || 0)),
          0,
        );
        const pct = rawTotal > 0 ? ((totalDiscountINR / rawTotal) * 100).toFixed(2) : "0.00";
        setSpecialDiscountPct(pct);
        setSpecialDiscountINR(totalDiscountINR.toFixed(2));
      }

      storeMedicineToTrackDestroy(
        invoiceDetails?.medicines?.map((medicine) => {
          const matchedInvoiceItem = invoiceDetails?.invoice_items?.find(
            (item) => item.invoice_itemable_id === medicine.id,
          );

          return {
            id: medicine?.id,
            name: medicine?.name || "",
            batchId: medicine?.batch || null,
            batch:
              medicine?.medicine_batches?.find(
                (batch) => batch?.id === medicine?.batch,
              ) || null,
            batchArray: medicine?.medicine_batches || [],
            stock: medicine?.stock_left,
            packing:
              (medicine?.medicine_batches?.length > 0 &&
                medicine?.medicine_batches[0]?.packing) ||
              "",
            unitMrp: medicine?.returned
              ? -medicine.unit_price
              : medicine.unit_price,
            mrp: medicine?.returned ? -medicine.mrp : medicine.mrp,
            discount: `-${medicine?.discount || 0}%`,
            gst: medicine?.gst || 0,
            amount: medicine?.returned
              ? -(medicine?.grand_total || 0)
              : medicine?.grand_total || 0,
            expiry_date: medicine?.medicine_batches[0]?.expiry_date,
            quantity: medicine?.quantity || 1,
            returned: medicine?.returned,
            invoice_id: matchedInvoiceItem?.id || null, // <-- This line adds invoice_id
          };
        }),
      );

      const normalizePayments = (payments = []) => {
        if (!Array.isArray(payments) || payments.length === 0) return null;

        return payments.slice(0, 2).map((p, idx) => ({
          id: p?.id || null,
          amount: p?.amount != null ? String(Math.abs(Number(p.amount))) : "",
          payment_mode: p?.payment_mode || (idx === 0 ? "UPI" : "Cash"),
        }));
      };
      const pref = normalizePayments(invoiceDetails?.invoice_payments);

      if (pref && !paymentsHydratedRef.current) {
        paymentsHydratedRef.current = true;
        setInvoicePaymentsAttributes(pref);
      }
    }
  }, [invoiceDetails]);

  const resetModalState = () => {
    setFormState({
      full_name: "",
      uid: "",
      mobile: "",
      email: "",
      dob: "",
      gender: "",
      patient_id: "",
      prescription_id: null,
      invoice_id: "",
    });
    setMedicines([
      {
        id: "",
        name: "",
        quantity: "",
        batchId: null,
        batch: "",
        batchArray: [],
        returned: false,
        stock: "",
        packing: "",
        unitMrp: null,
        mrp: null,
        discount: null,
        gst: null,
        amount: null,
      },
    ]);
    storeMedicineToTrackDestroy([]);
    setTotal(0);
    setSelect(null);
    setSelectedMedicine(null);
    setShowButton(true);
    setPrintInvoiceData({});
    setSearchTerm("");
    setFilteredMedicines([]);
    setOpenMedicines(false);
    setHighlightedIndexMedicine(0);
    setIsButtonDisable(false);
    setIsFormChanged(false);
    setInvoicePaymentsAttributes([
      { id: null, amount: "", payment_mode: "UPI" },
    ]);
    setErrors({});
    setDeleteModal(false);
    paymentsHydratedRef.current = false;
  };

  //handle form change
  // const handleFocusMedicineName = (e) => {
  //   const { name, value } = e.target;
  //   setFormState((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  // };

  const handleAddRow = () => {
    setMedicines([
      ...medicines,
      {
        name: "",
        quantity: "",
        batch: "",
        return: false,
        stock: "",
        packing: "",
        UnitMRP: null,
        MRP: null,
        GST: null,
        amount: null,
      },
    ]);
  };

  // handle key down with  enter  logic
  const handleChange = (index, field, value) => {
    const newMedicines = medicines.map((medicine, idx) =>
      idx === index ? { ...medicine, [field]: value } : medicine,
    );
    setMedicines(newMedicines);
  };

  const handleSearch = (event) => {
    // console.log(event.target.value);
    const query = event.target.value.toLowerCase();
    setSearchTerm(query);

    const storedMedicines =
      JSON.parse(localStorage.getItem("allMedicines")) || [];

    // Filter medicines based on search query
    const filteredMedicineList = storedMedicines.filter((medicine) =>
      medicine[1].toLowerCase().startsWith(query),
    );

    // Limit the results to top 10 and sort
    let limitedResults = filteredMedicineList.slice(0, 10);
    if (!query) {
      limitedResults = [];
      // console.log(limitedResults)
      setHighlightedIndexMedicine(0);
    }
    setFilteredMedicines(limitedResults);
  };

  // const updateNameAndId = (index, value) => {
  //   const newMedicines = [...medicines];
  //   newMedicines[index] = { ...newMedicines[index], id: value[0], name: value[1] };
  //   setMedicines(newMedicines);
  // }

  // const handleKeyDown = (e, index, field) => {
  //   if (field === "name") {

  //     if (["ArrowDown", "ArrowUp"].includes(e.key)) {
  //       e.preventDefault();
  //       // Navigate options with arrow keys
  //       setHighlightedIndexMedicine((prevIndex) => {
  //         if (e.key === "ArrowDown") {
  //           return prevIndex < filteredMedicines?.length - 1
  //             ? prevIndex + 1
  //             : 0;
  //         } else {
  //           return prevIndex > 0
  //             ? prevIndex - 1
  //             : filteredMedicines?.length - 1;
  //         }
  //       });
  //     }

  //     else if (e.key === "Tab") {
  //       if (!medicines[index]?.name) {
  //         setTimeout(() => document.getElementById(`submit`).focus(), 0);
  //         return;
  //       }

  //       e.preventDefault();
  //       const topOption = filteredMedicines[highlightedIndexMedicine];

  //       if (topOption) {
  //         updateNameAndId(index, topOption);
  //         handlePresence(index, topOption);
  //         setHighlightedIndexMedicine(0);
  //         setTimeout(
  //           () => document.getElementById(`quantity-${index}`).focus(),
  //           0
  //         );
  //       } else {
  //         setHighlightedIndexMedicine(0);
  //         setTimeout(
  //           () => document.getElementById(`quantity-${index}`).focus(),
  //           0
  //         ); // Focus next field
  //       }
  //     }

  //     else if (e.key === "Enter") {
  //       if (!medicines[index]?.name) {
  //         setTimeout(() => document.getElementById(`submit`).focus(), 0);
  //         return;
  //       }

  //       e.preventDefault();
  //       const topOption = filteredMedicines[highlightedIndexMedicine];

  //       if (topOption) {
  //         setTimeout(() => {
  //           setHighlightedIndexMedicine(0);
  //           updateNameAndId(index, topOption); // Ensure this is wrapped inside a function
  //           handlePresence(index, topOption); // Ensure this is wrapped inside a function
  //           setSelectedMedicine({ name: topOption[1], id: topOption[0] });
  //           // document.getElementById(`description-${index}`).focus(); // Focus next field
  //         }, 0);
  //       }
  //     }
  //   }
  //   else if (e.key === "Enter" && field === "quantity") {
  //     setTimeout(() => document.getElementById(`return-${index}`).focus(), 0);
  //   }
  //   else if (e.key === "Enter" && field === "return") {
  //     handleAddRow();
  //     setTimeout(() => document.getElementById(`name-${index + 1}`).focus(), 0);
  //   }
  // };

  const updateNameAndId = (index, value) => {
    setMedicines((prevMedicines) =>
      prevMedicines.map((medicine, idx) =>
        idx === index
          ? {
              ...medicine,
              id: value[0],
              name: value[1],
              quantity: "",
              batchId: null,
              batch: "",
              batchArray: [],
              returned: false,
              stock: "",
              packing: "",
              unitMrp: null,
              mrp: null,
              discount: null,
              gst: null,
              amount: null,
            }
          : medicine,
      ),
    );
  };

  const handleKeyDown = (e, index, field) => {
    if (field === "name") {
      if (["ArrowDown", "ArrowUp"].includes(e.key)) {
        e.preventDefault();
        // Navigate options with arrow keys
        setHighlightedIndexMedicine((prevIndex) => {
          if (e.key === "ArrowDown") {
            return prevIndex < filteredMedicines?.length - 1
              ? prevIndex + 1
              : 0;
          } else {
            return prevIndex > 0
              ? prevIndex - 1
              : filteredMedicines?.length - 1;
          }
        });
      } else if (e.key === "Tab") {
        if (!medicines[index]?.name) {
          setTimeout(() => document.getElementById(`submit`).focus(), 0);
          return;
        }

        e.preventDefault();
        const topOption = filteredMedicines[highlightedIndexMedicine];

        if (topOption) {
          updateNameAndId(index, topOption);
          handlePresence(index, topOption);
          setHighlightedIndexMedicine(0);
          setTimeout(() => {
            document.getElementById(`quantity-${index}`).focus();
          }, 0);
        } else {
          setHighlightedIndexMedicine(0);
          setTimeout(
            () => document.getElementById(`quantity-${index}`).focus(),
            0,
          ); // Focus next field
        }
      } else if (e.key === "Enter") {
        if (!medicines[index]?.name) {
          setTimeout(() => document.getElementById(`submit`).focus(), 0);
          return;
        }

        e.preventDefault();
        e.stopPropagation();
        const topOption = filteredMedicines[highlightedIndexMedicine];

        if (topOption) {
          // setTimeout(() => {
          //   setHighlightedIndexMedicine(0);
          //   updateNameAndId(index, topOption); // Ensure this is wrapped inside a function
          //   handlePresence(index, topOption); // Ensure this is wrapped inside a function
          //   setSelectedMedicine({ name: topOption[1], id: topOption[0] });
          //   // document.getElementById(`description-${index}`).focus(); // Focus next field
          // }, 100);
          setTimeout(() => {
            // setHighlightedIndexMedicine(0);
            updateNameAndId(index, topOption);
            handlePresence(index, topOption);
            setTimeout(() => {
              setHighlightedIndexMedicine(0);
              document.getElementById(`quantity-${index}`).focus();
            }, 0);
          }, 100);
        } else {
          setHighlightedIndexMedicine(0);
          setTimeout(() => {
            document.getElementById(`quantity-${index}`).focus();
          }, 0);
        }
      }
    } else if (e.key === "Enter" && field === "quantity") {
      const returnField = document.getElementById(`return-${index}`);

      // agar return field nahi hai ya disabled hai toh skip karo
      if (!returnField || returnField.disabled) {
        handleAddRow();
        setTimeout(
          () => document.getElementById(`name-${index + 1}`).focus(),
          200,
        );
      } else {
        setTimeout(() => {
          returnField.focus();
        }, 0);
      }
      // setTimeout(() => document.getElementById(`return-${index}`).focus(), 0);
      // if (medicines?.length > index + 1) {
      //   setTimeout(
      //     () => document.getElementById(`name-${index + 1}`).focus(),
      //     100
      //   );
      // } else {
      //   handleAddRow();
      //   setTimeout(() => document.getElementById(`name-${index + 1}`).focus(), 200);
      // }
    } else if (e.key === "Tab" && field === "return") {
      if (medicines?.length > index + 1) {
        setTimeout(
          () => document.getElementById(`name-${index + 1}`).focus(),
          100,
        );
      } else {
        handleAddRow();
        setTimeout(
          () => document.getElementById(`name-${index + 1}`).focus(),
          200,
        );
      }
    } else if (e.key === "Enter" && field === "return") {
      if (medicines?.length > index + 1) {
        setTimeout(
          () => document.getElementById(`name-${index + 1}`).focus(),
          100,
        );
      } else {
        handleAddRow();
        setTimeout(
          () => document.getElementById(`name-${index + 1}`).focus(),
          200,
        );
      }
    }
  };

  const handlePresence = async (index, value) => {
    // Exclude the row being modified (not just the last row) so that re-selecting
    // the same medicine or modifying a non-last row doesn't trigger a false duplicate.
    const medicineNames = medicines
      ?.filter((_, idx) => idx !== index)
      .map((med) => med.name)
      .join(",");
    try {
      const res = await getMedicineByName(
        encodeURIComponent(medicineNames),
        encodeURIComponent(value[1]),
      );

      if (res?.payload?.presence) {
        // Use functional updater to avoid stale closure overwriting newer state
        setMedicines((prevMedicines) =>
          prevMedicines.map((medicine, i) =>
            i === index
              ? { ...medicine, id: "", name: "", description: "", remark: "" }
              : medicine,
          ),
        );
        showToast("Medicine already present in the list", "ERROR");
      }
    } catch (error) {
      console.log(error);
    }
    setFilteredMedicines([]);
  };

  const handleMedicineChange = (index, field, value) => {
    const newMedicines = medicines.map((medicine, idx) =>
      idx === index ? { ...medicine, [field]: value } : medicine,
    );
    setMedicines(newMedicines);
    // console.log(index,value);
  };

  useEffect(() => {
    paymentsHydratedRef.current = false;
  }, [id]);

  //packing and stock show after select medicine
  useEffect(() => {
    if (medicineDetail && select !== null) {
      setMedicines((prevMedicines) =>
        prevMedicines.map((medicine, idx) =>
          idx === select
            ? {
                ...medicine,
                stock: medicineDetail?.payload?.stock_left,
                packing: medicineDetail?.payload?.packing,
              }
            : medicine,
        ),
      );
      // console.log(packing, stock_left, '<-stock and packing');
    }
  }, [medicineDetail, select]);

  //  console.log(medicines);
  const handleQuantityChange = (index, field, value) => {
    if (value) {
      // console.log("hello");
      setMedicines((prevMedicines) =>
        prevMedicines.map((medicine, idx) =>
          idx === index
            ? {
                ...medicine,
                packing: "",
                unitMrp: null,
                mrp: null,
                discount: null,
                gst: null,
                amount: null,
              }
            : medicine,
        ),
      );

      // setSelectedMedicine(null);
    }

    const newMedicines = medicines?.map((medicine, idx) =>
      idx === index ? { ...medicine, [field]: value } : medicine,
    );

    setMedicines(newMedicines);
    // dispatch(setLoading(true));
    if (priceRequestControllers.current.has(index)) {
      priceRequestControllers.current.get(index).abort();
      priceRequestControllers.current.delete(index);
      pendingPriceCount.current -= 1;
      if (pendingPriceCount.current < 0) pendingPriceCount.current = 0;
    }

    if (medicines[index]?.id) {
      const controller = new AbortController();
      priceRequestControllers.current.set(index, controller);
      pendingPriceCount.current += 1;
      setIsPriceFetching(true);

      getPriceByQuantity(
        medicines[index].id,
        field === "batchId" ? medicines[index].quantity : value,
        field === "batchId" ? value : medicines[index].batchId,
        invoiceDetails?.prescription_id,
        controller.signal,
      )
        .then((res) => {
          // Error response (e.g. selected batch is out of stock) or malformed body
          if (res?.__httpError || !res?.payload?.batches) {
            console.log("get_price_by_quantity error body:", res);
            showToast(
              res?.payload?.message ||
                res?.status?.message ||
                res?.message ||
                res?.error ||
                res?.errors?.[0] ||
                "Selected batch is out of stock or unavailable.",
              "ERROR",
            );
            // Flag this row so the batch cell shows a red border
            setMedicines((prev) =>
              prev.map((medicine, idx) =>
                idx === index ? { ...medicine, batchError: true } : medicine,
              ),
            );
            return;
          }

          const {
            selected_batch,
            discount,
            mrp,
            batches,
            unit_price,
            grand_total,
            stock_left,
            is_consumable,
          } = res.payload;

          const matchedBatch = batches?.find((b) => b.id === selected_batch?.id);

          // Update the medicine entry with the new price data
          const updatedMedicines = newMedicines.map((medicine, idx) =>
            idx === index
              ? {
                  ...medicine,
                  batchId: selected_batch?.id,
                  batch: matchedBatch || selected_batch,
                  batchArray: batches,
                  stock: stock_left,
                  packing: matchedBatch?.packing || batches[0]?.packing,
                  unitMrp: medicine.returned ? -unit_price : unit_price,
                  mrp: medicine.returned ? -mrp : mrp,
                  discount: medicine.returned
                    ? `-${discount}%`
                    : `${discount}%`,
                  gst: matchedBatch?.gst ?? 0,
                  amount: medicine.returned ? -grand_total : grand_total,
                  is_consumable,
                  batchError: false,
                }
              : medicine,
          );
          setMedicines(updatedMedicines);
          //  dispatch(setLoading(false));
        })
        .catch((error) => {
          if (error?.name === "AbortError") return; // cancelled — ignore
          console.error("Error fetching price:", error);
          showToast(
            error?.status?.message || "Something went wrong fetching price.",
            "ERROR",
          );
          // Flag this row so the batch cell shows a red border
          setMedicines((prev) =>
            prev.map((medicine, idx) =>
              idx === index ? { ...medicine, batchError: true } : medicine,
            ),
          );
        })
        .finally(() => {
          priceRequestControllers.current.delete(index);
          pendingPriceCount.current -= 1;
          if (pendingPriceCount.current <= 0) {
            pendingPriceCount.current = 0;
            setIsPriceFetching(false);
          }
        });
    }
  };

  // console.log(medicines);
  const handleReturnChange = (index) => {
    const newMedicines = medicines?.map((medicine, idx) =>
      idx === index ? { ...medicine, returned: !medicine.returned } : medicine,
    );
    setMedicines(newMedicines);
    if (priceRequestControllers.current.has(index)) {
      priceRequestControllers.current.get(index).abort();
      priceRequestControllers.current.delete(index);
      pendingPriceCount.current -= 1;
      if (pendingPriceCount.current < 0) pendingPriceCount.current = 0;
    }

    const controller = new AbortController();
    priceRequestControllers.current.set(index, controller);
    pendingPriceCount.current += 1;
    setIsPriceFetching(true);

    getPriceByQuantityForReturn(
      medicines[index].id,
      medicines[index].quantity,
      invoiceDetails?.prescription_id,
      controller.signal,
    )
      .then((res) => {
        console.log(res.payload);
        const {
          selected_batch,
          discount,
          mrp,
          batches,
          unit_price,
          grand_total,
        } = res.payload;

        const matchedBatch = batches?.find((b) => b.id === selected_batch?.id);

        // Update the medicine entry with the new price data
        const updatedMedicines = newMedicines.map((medicine, idx) =>
          idx === index
            ? {
                ...medicine,
                batchId: selected_batch?.id,
                batch: matchedBatch || selected_batch,
                batchArray: batches,
                stock: selected_batch?.stock_left,
                packing: matchedBatch?.packing || batches[0]?.packing,
                unitMrp: medicine.returned ? -unit_price : unit_price,
                mrp: medicine.returned ? -mrp : mrp,
                discount: medicine.returned ? `-${discount}%` : `${discount}%`,
                gst: matchedBatch?.gst ?? 0,
                amount: medicine.returned ? -grand_total : grand_total,
              }
            : medicine,
        );

        setMedicines(updatedMedicines);
      })
      .catch((error) => {
        console.error("Error fetching price:", error);
      })
      .finally(() => {
        // ← ADD THIS
        priceRequestControllers.current.delete(index);
        pendingPriceCount.current -= 1;
        if (pendingPriceCount.current <= 0) {
          pendingPriceCount.current = 0;
          setIsPriceFetching(false);
        }
      });
  };

  const handleRemoveRow = (index) => {
    const newMedicines = medicines.filter((_, idx) => idx !== index);
    setMedicines(newMedicines);
  };

  const [editMedicine, setEditMedicine] = useState(false);
  const [selectedMedicineForEdit, setSelectedMedicineForEdit] = useState(null);

  useEffect(() => {
    let totalAmount = 0;
    let validMedicinesCount = 0;
    let hasInvalidQuantity = false;
    let discountTotal = 0;
    let gstTotal = 0;
    const spDiscPct = parseFloat(specialDiscountPct) || 0;

    medicines?.forEach((medicine) => {
      if (
        medicine?.name &&
        medicine?.quantity &&
        medicine?.quantity > 0 &&
        medicine?.id
      ) {
        validMedicinesCount++;
        const unitMrpAbs = parseFloat(medicine.unitMrp) || 0;
        const rawAmt = unitMrpAbs * (parseFloat(medicine.quantity) || 0);
        const amount = spDiscPct > 0 ? rawAmt * (1 - spDiscPct / 100) : (parseFloat(medicine.amount) || 0);
        const gstPct = parseFloat(medicine.gst) || 0;
        const gstAmount = amount * gstPct / (100 + gstPct);

        totalAmount += amount;
        gstTotal += gstAmount;

        const rawAmtAbs = Math.abs(rawAmt);
        if (rawAmtAbs > 0) {
          const effectivePct = spDiscPct > 0 ? spDiscPct : (parseFloat(medicine.discount) || 0);
          discountTotal += rawAmtAbs * (effectivePct / 100);
        }
      }

      if (medicine.name && (!medicine.quantity || medicine.quantity <= 0)) {
        hasInvalidQuantity = true;
      }
    });

    const taxableTotal = totalAmount - gstTotal;
    const netPayable = roundToNearestUnit(totalAmount, roundOff);
    setSelect(validMedicinesCount);
    setTotal(netPayable);
    setBillSummary({
      taxableTotal,
      totalGst: gstTotal,
      discount: discountTotal,
      netPayable,
    });

    setShowButton(!hasInvalidQuantity && validMedicinesCount > 0);
    if (priceRequestControllers.current.size === 0 && isPriceFetching) {
      pendingPriceCount.current = 0;
      setIsPriceFetching(false);
    }
  }, [medicines, roundOff, specialDiscountPct]);

  const [deleteModal, setDeleteModal] = useState(false);
  const printRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "medicine invoice Print",
    onAfterPrint: () => console.log("Print job finished"),
  });

  specialDiscountPctRef.current = specialDiscountPct;

  useEffect(() => {
    const pct = parseFloat(specialDiscountPctRef.current);
    if (!specialDiscountPctRef.current || isNaN(pct) || pct <= 0) return;
    const raw = medicines.reduce((sum, m) => {
      if (m.name && m.quantity > 0 && m.id)
        return sum + Math.abs(parseFloat(m.unitMrp) || 0) * Math.abs(parseFloat(m.quantity) || 0);
      return sum;
    }, 0);
    setSpecialDiscountINR((raw * pct / 100).toFixed(2));
  }, [medicines]);

  // console.log(formState, 'formState');

  const toNum = (v) => {
    const n = parseFloat(v);
    return Number.isFinite(n) ? n : 0;
  };

  // 1) Default: keep row-0 amount synced with total (only when NOT already split)
  // const toNum = (v) => {
  //   const n = parseFloat(v);
  //   return Number.isFinite(n) ? n : 0;
  // };

  useEffect(() => {
    setInvoicePaymentsAttributes((prev) => {
      const absT = Math.abs(Number(billSummary.netPayable || 0));

      // If payments came from API, do NOT override row-0.
      // Only keep row-2 in sync if split exists.
      if (paymentsHydratedRef.current) {
        if (prev.length === 2) {
          const a1 = toNum(prev[0]?.amount);
          const remaining = Math.max(absT - a1, 0).toFixed(2);
          return [{ ...prev[0] }, { ...prev[1], amount: remaining }];
        }

        // single row => just ensure it equals abs netPayable
        return [{ ...prev[0], amount: absT.toFixed(2) }];
      }

      // NOT hydrated: your default behavior
      if (prev.length === 2) {
        const a1 = toNum(prev[0]?.amount);
        const remaining = Math.max(absT - a1, 0);
        return [{ ...prev[0] }, { ...prev[1], amount: remaining.toFixed(2) }];
      }

      const row0 = prev[0] || { payment_mode: "UPI", amount: "" };
      return [{ ...row0, amount: absT.toFixed(2) }];
    });
  }, [billSummary.netPayable]);

  // 2) When user edits first amount -> auto create/update/remove second row
  const handlePrimaryAmountChange = (value) => {
    setInvoicePaymentsAttributes((prev) => {
      const absT = Math.abs(Number(billSummary.netPayable || 0));
      const a1 = toNum(value);

      // If empty or zero, keep single row (collapse finalised on blur)
      if (value === "" || a1 === 0) {
        return [{ ...prev[0], amount: value }];
      }

      // If user enters >= abs total => keep single row only
      if (a1 >= absT) {
        return [{ ...prev[0], amount: value }];
      }

      // If user enters less than abs total => create/update second row for remaining
      const remaining = (absT - a1).toFixed(2);
      const row0 = { ...prev[0], amount: value };

      // if row2 exists update it else create it
      if (prev.length === 2) {
        return [row0, { ...prev[1], amount: remaining }];
      }

      return [
        row0,
        {
          amount: remaining,
          payment_mode: getAvailablePaymentModes(1)[0]?.value,
        }, // default second mode
      ];
    });
  };

  // 3) On blur: if primary is 0 or empty, collapse to single row
  const handlePrimaryAmountBlur = () => {
    setInvoicePaymentsAttributes((prev) => {
      const a1 = toNum(prev[0]?.amount);
      if (a1 === 0 || prev[0]?.amount === "") {
        const absT = Math.abs(Number(billSummary.netPayable || 0));
        return [{ ...prev[0], amount: absT.toFixed(2) }];
      }
      return prev;
    });
  };

  const updatePaymentRow = (index, key, value) => {
    setInvoicePaymentsAttributes((prev) =>
      prev.map((row, i) => (i === index ? { ...row, [key]: value } : row)),
    );
  };

  //   const paidTotal = invoicePaymentsAttributes.reduce(
  //   (sum, row) => sum + toNum(row?.amount),
  //   0,
  // );

  // const remainingTotal = (Number(total || 0) - paidTotal).toFixed(2);

  const validateForm = () => {
    let formValid = true;
    const newErrors = {};

    if (!formState.full_name) {
      newErrors.full_name = "Full Name cannot be blank";
      formValid = false;
    }

    // Mobile number validation (10 digits)
    if (!formState?.mobile) {
      newErrors.mobile = "Mobile cannot be blank";
      formValid = false;
    } else if (!/^\d{10}$/.test(formState.mobile)) {
      newErrors.mobile = "Please enter a valid 10-digit mobile number";
      formValid = false;
    }

    // Email validation using regex pattern
    // const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // if (!formState?.email) {
    //   newErrors.email = "Email cannot be blank";
    //   formValid = false;
    // } else if (!emailPattern.test(formState.email)) {
    //   newErrors.email = "Please enter a valid email address";
    //   formValid = false;
    // }

    if (!formState?.dob) {
      newErrors.dob = "Date of Birth cannot be blank";
      formValid = false;
    }
    if (!formState?.gender) {
      newErrors.gender = "Gender cannot be blank";
      formValid = false;
    }

    // Validate medicines
    // medicines.forEach((medicine, index) => {
    //   if (!medicine.name) {
    //     newErrors[`medicine_name_${index}`] = "Medicine name cannot be blank";
    //     formValid = false;
    //   }
    //   if (!medicine.quantity) {
    //     newErrors[`medicine_quantity_${index}`] = "Quantity cannot be blank";
    //     formValid = false;
    //   }
    // });

    setErrors(newErrors);
    return formValid;
  };

  const handleSavePatientInfo = async () => {
    setIsButtonDisable(true);
    if (!validateForm()) {
      setIsButtonDisable(false);
      return;
    }

    const invoice = {
      invoice_id: id,
      invoice: {
        name: formState.full_name,
        dob: formState.dob,
        gender: formState.gender,
        mobile: formState.mobile,
        email: formState.email,
      },
    };
    try {
      const res = await editPharmacyPatient(invoice);
      // console.log(res, 'res');
      refetch();
      // console.log(res);
      if (res?.status?.status === "SUCCESS") {
        setFormState((prev) => ({ ...prev, invoice_id: res?.payload?.id }));
        showToast(res.status.message || res.status.status, res.status.status);
        setTimeout(() => {
          // handlePrint();
          resetModalState();
          onClose();
        }, 0);
      } else {
        showToast(res.status.message || res.status.status, res.status.status);
      }
    } catch (error) {
      console.log(error, "error");
    }
    setIsButtonDisable(false);
  };

  // console.log(medicines, 'medicines')
  const saveAndPrint = async () => {
    if (isPriceFetching) {
      showToast("Price update in progress, please wait.", "WARNING");
      return;
    }
    setIsButtonDisable(true);

    const invalidMedicines = medicines.filter(
      (medicine) =>
        medicine?.id && !medicine?.batchId && medicine?.is_consumable === false,
    );

    if (invalidMedicines.length > 0) {
      const names = invalidMedicines.map((m) => `[${m.name}]`).join(", ");
      showToast(
        `Batch not selected for ${names}. Please either select a batch or remove the medicine.`,
        "ERROR",
      );
      setIsButtonDisable(false);
      return;
    }

    const validMedicines = medicines?.filter(
      (medicine) =>
        medicine?.id && medicine?.quantity && medicine?.quantity > 0,
    );

    if (validMedicines?.length === 0) {
      showToast(
        "At least one medicine is required to generate the invoice.",
        "ERROR",
      );
      setIsButtonDisable(false);
      return;
    }
    // ✅ DUPLICATE MEDICINE VALIDATION
    const medicineIds = validMedicines.map((m) => m.id);
    const duplicateMedicines = validMedicines.filter(
      (item, index) => medicineIds.indexOf(item.id) !== index,
    );

    if (duplicateMedicines.length > 0) {
      const duplicateNames = [
        ...new Set(duplicateMedicines.map((m) => `[${m.name}]`)),
      ].join(", ");
      showToast(
        `Duplicate medicine found for ${duplicateNames}. Please combine quantities into a single row or remove duplicates.`,
        "ERROR",
      );
      setIsButtonDisable(false);
      return;
    }

    const itemsToDestroy =
      medicineToTrackDestroy
        ?.filter((oldItem) => {
          return !validMedicines?.some((newItem) => newItem.id === oldItem.id);
        })
        ?.map((item) => ({ ...item, _destroy: 1 })) || [];

    // ✅ Stock Validation Check
    const insufficientStock = validMedicines?.filter((med) => {
      // Only check for items that are NOT returned
      if (!med?.returned && !med?.invoice_id) {
        const batchStock = med?.stock || 0;
        const requiredQty = med?.quantity || 0;
        return requiredQty > batchStock;
      }
      return false;
    });

    if (insufficientStock?.length > 0) {
      const errorMsg = insufficientStock
        .map(
          (med) =>
            `[${med?.name}] Batches , Available stocks: ${med?.stock || 0}, Required: ${med?.quantity})`,
        )
        .join(", ");
      showToast(`Insufficient stock for ${errorMsg}`, "ERROR");
      setIsButtonDisable(false);
      return;
    }

    // const formattedMedicines = [
    //   ...[...validMedicines, ...itemsToDestroy]?.map((medicine) => ({
    //     id: medicine?.id,
    //     name: medicine.name,
    //     batch: medicine?.batch?.id,
    //     packing: medicine?.packing,
    //     quantity: medicine?.quantity,
    //     cost_per_unit: medicine?.unitMrp,
    //     cost: (medicine?.unitMrp * medicine?.quantity).toFixed(2),
    //     amount: medicine?.amount,
    //     discount_per_unit: (
    //       (medicine?.quantity * medicine?.unitMrp - medicine?.amount) /
    //       +medicine?.quantity
    //     ).toFixed(2),
    //     discount: (
    //       medicine?.quantity * medicine?.unitMrp -
    //       medicine?.amount
    //     ).toFixed(2),
    //     ...(medicine?.invoice_id && { invoice_item_id: medicine.invoice_id }),
    //     _destroy: medicine?._destroy || 0,
    //     returned: medicine?.returned,
    //   })),
    // ];

    // console.log(formState, "formState");

    const spDiscPct = parseFloat(specialDiscountPct) || 0;

    const formattedMedicines = [...validMedicines, ...itemsToDestroy].map(
      (medicine) => {
        const qty = Number(medicine?.quantity || 0);
        const sign = medicine?.returned ? -1 : 1;

        const unitPriceAbs = Math.abs(Number(medicine?.unitMrp || 0));
        const rawAmtAbs = unitPriceAbs * qty;
        const effectivePct = spDiscPct > 0 ? spDiscPct : (parseFloat(medicine?.discount) || 0);
        const effectiveAmountAbs = spDiscPct > 0 ? rawAmtAbs * (1 - spDiscPct / 100) : Math.abs(Number(medicine?.amount || 0));

        const costPerUnit = sign * unitPriceAbs;
        const cost = sign * rawAmtAbs;
        const amount = sign * effectiveAmountAbs;

        const discountValue = rawAmtAbs * (effectivePct / 100);
        const discountPerUnit = unitPriceAbs * (effectivePct / 100);

        return {
          id: medicine?.id,
          name: medicine?.name,
          batch: medicine?.batch?.id,
          packing: medicine?.packing,
          quantity: qty,
          cost_per_unit: costPerUnit,
          cost: cost.toFixed(2),
          amount: amount.toFixed(2),
          discount_per_unit: discountPerUnit.toFixed(2),
          discount: discountValue.toFixed(2),
          ...(spDiscPct > 0 ? { special_discount: spDiscPct } : {}),
          ...(medicine?.invoice_id && { invoice_item_id: medicine.invoice_id }),
          _destroy: medicine?._destroy || 0,
          returned: medicine?.returned,
        };
      },
    );

    // const total = medicines.reduce((sum, medicine) => {
    //   return sum + (medicine?.unitMrp || 0) * (medicine?.quantity || 0);
    // }, 0);

    // const grandTotal = medicines.reduce((sum, medicine) => {
    //   return sum + (medicine?.amount || 0);
    // }, 0);

    const total = validMedicines.reduce((sum, medicine) => {
      const sign = medicine?.returned ? -1 : 1;
      return (
        sum +
        sign *
          Math.abs(Number(medicine?.unitMrp || 0)) *
          Number(medicine?.quantity || 0)
      );
    }, 0);

    // MRP is GST-inclusive: extract GST from GST-inclusive amount
    const netTotal = validMedicines.reduce((sum, medicine) => {
      const sign = medicine?.returned ? -1 : 1;
      const unitPriceAbs = Math.abs(Number(medicine?.unitMrp || 0));
      const rawAmtAbs = unitPriceAbs * Number(medicine?.quantity || 0);
      const effectiveAmountAbs = spDiscPct > 0 ? rawAmtAbs * (1 - spDiscPct / 100) : Math.abs(Number(medicine?.amount || 0));
      return sum + sign * effectiveAmountAbs;
    }, 0);

    const totalGst = validMedicines.reduce((sum, medicine) => {
      const sign = medicine?.returned ? -1 : 1;
      const unitPriceAbs = Math.abs(Number(medicine?.unitMrp || 0));
      const rawAmtAbs = unitPriceAbs * Number(medicine?.quantity || 0);
      const effectiveAmountAbs = spDiscPct > 0 ? rawAmtAbs * (1 - spDiscPct / 100) : Math.abs(Number(medicine?.amount || 0));
      const amt = sign * effectiveAmountAbs;
      const gstPct = parseFloat(medicine?.gst) || 0;
      return sum + amt * gstPct / (100 + gstPct);
    }, 0);

    const taxableTotal = netTotal - totalGst;
    const cgst = totalGst / 2;
    const sgst = totalGst / 2;
    const grandTotal = roundToNearestUnit(netTotal, roundOff);

    const discount = validMedicines.reduce((sum, medicine) => {
      const effectivePct = spDiscPct > 0 ? spDiscPct : (parseFloat(medicine?.discount) || 0);
      const itemMrp = Math.abs(Number(medicine?.unitMrp || 0)) * Number(medicine?.quantity || 0);
      return sum + itemMrp * (effectivePct / 100);
    }, 0);

    console.log("Bill Summary:", {
      total: total.toFixed(2),
      taxable_total: taxableTotal.toFixed(2),
      total_gst: totalGst.toFixed(2),
      cgst: cgst.toFixed(2),
      sgst: sgst.toFixed(2),
      grand_total: grandTotal.toFixed(2),
      discount: discount.toFixed(2),
    });

    const existingPayments = (invoiceDetails?.invoice_payments || []).slice(
      0,
      2,
    );
    const currentPayments = invoicePaymentsAttributes.slice(0, 2);

    const invoice_payments_attributes = [
      // current rows => update/create
      ...currentPayments.map((p) => ({
        ...(p?.id ? { id: p.id } : {}),
        amount: Number(toNum(p.amount).toFixed(2)),
        payment_mode: p.payment_mode,
      })),

      // removed rows => destroy
      ...existingPayments
        .filter(
          (oldPayment) =>
            !currentPayments.some(
              (p) => Number(p?.id) === Number(oldPayment?.id),
            ),
        )
        .map((oldPayment) => ({
          id: oldPayment.id,
          _destroy: 1,
        })),
    ];

    if (formState?.patient_id) {
      const payload = {
        // patient: {
        //   full_name: formState.full_name,
        //   dob: formState.dob,
        //   gender: formState.gender,
        //   mobile: formState.mobile,
        //   email: formState.email,
        // },
        is_return: false,
        patient_id: formState?.patient_id || null,
        prescription_id: formState?.prescription_id || null,
        invoice_id: formState?.invoice_id || null,
        discount: discount.toFixed(2),
        ...(spDiscPct > 0 ? { special_discount: spDiscPct } : {}),
        total: total.toFixed(2),
        taxable_total: taxableTotal.toFixed(2),
        cgst: cgst.toFixed(2),
        sgst: sgst.toFixed(2),
        grand_total: grandTotal.toFixed(2),
        config_round_off: roundOff,
        medicines: formattedMedicines,
        invoice_payments_attributes,
      };
      const res = await pharmacyUpdateBill(payload);
      setPrintInvoiceData(res);
      // console.log(res, "<-res");

      // const statusMessage = res?.status?.status || "ERROR";
      // const detailedMessage = res?.status?.message || "Something went wrong";
      // showToast(statusMessage, detailedMessage);

      if (res.status.status === "SUCCESS") {
        setFormState((prev) => ({ ...prev, invoice_id: res?.payload?.id }));
        showToast(
          res?.status?.message || res?.status?.status,
          res?.status?.status,
        );

        showToast(`Generating Invoice Print`, "SUCCESS");
        setTimeout(() => {
          handlePrint();
          resetModalState();
          onClose();
        }, 0);
      } else {
        showToast(res.status.message || res.status.status, res.status.status);
      }
      refetch();
      // setOpenBillByInvoice(false);
    } else {
      if (!validateForm()) {
        setIsButtonDisable(false);
        return;
      }
      const payload = {
        patient: {
          full_name: formState.full_name,
          dob: formState.dob,
          gender: formState.gender,
          mobile: formState.mobile,
          email: formState.email,
        },
        is_return: false,
        discount: discount.toFixed(2),
        ...(spDiscPct > 0 ? { special_discount: spDiscPct } : {}),
        total: total.toFixed(2),
        taxable_total: taxableTotal.toFixed(2),
        cgst: cgst.toFixed(2),
        sgst: sgst.toFixed(2),
        grand_total: grandTotal.toFixed(2),
        config_round_off: roundOff,
        invoice_id: formState?.invoice_id || null,
        medicines: formattedMedicines,
        invoice_payments_attributes,
      };

      const res = await pharmacyUpdateBill(payload);
      setPrintInvoiceData(res);
      refetch();
      // console.log(res);
      if (res.status.status === "SUCCESS") {
        setFormState((prev) => ({ ...prev, invoice_id: res?.payload?.id }));
        showToast(`Generating Invoice Print`, "SUCCESS");
        setTimeout(() => {
          handlePrint();
          onClose();
        }, 0);
      } else {
        showToast(res.status.message || res.status.status, res.status.status);
      }
      // const statusMessage = res?.status?.status || "ERROR";
      // const detailedMessage = res?.status?.message || "Something went wrong";
      // showToast(statusMessage, detailedMessage);
      // showToast(
      //   res?.status?.message || res?.status?.status,
      //   res?.status?.status
      // );
    }
    setIsButtonDisable(false);
  };
  //  console.log(medicines);

  //handle reprint  (invoiceId , prescriptionId)
  const rePrint = async () => {
    setIsButtonDisable(true);
    const res = await reprintInvoice(
      formState.invoice_id,
      formState.prescription_id,
    );
    setPrintInvoiceData(res);
    // console.log(res);
    if (res?.status?.status === "SUCCESS") {
      // setFormState((prev) => ({ ...prev, invoice_id?.res?.payload?.id }))
      setFormState((prev) => ({ ...prev, invoice_id: res?.payload?.id }));
      setTimeout(() => {
        handlePrint();
      }, 50);
    }
    const statusMessage = res?.status?.status || "ERROR";
    const detailedMessage = res?.status?.message || "Something went wrong";
    showToast(statusMessage, detailedMessage);
    showToast(res?.status?.message || res?.status?.status, res?.status?.status);
    // showToast(`Generating prescription PDF`, "SUCCESS");
    refetch();
    // setOpenBillByInvoice(false);
    setIsButtonDisable(false);
  };

  // refund and cancel
  const refundAndCancel = async () => {
    setIsButtonDisable(true);
    const res = await refundInvoice(formState.invoice_id);
    setPrintInvoiceData(res);
    // console.log(res)
    // console.log(res?.status?.status)
    if (res?.status?.status === "SUCCESS") {
      showToast("Refund invoice successful", "SUCCESS");
    } else {
      showToast(
        res?.status?.message || res?.status?.status,
        res?.status?.status,
      );
    }
    refetch();
    setTimeout(() => {
      setOpenBillByInvoice(false);
    }, 500);
    setIsButtonDisable(false);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    // setFormState((prev) => ({
    //   ...prev,
    //   [name]: value,
    // }));
    setFormState((prev) => {
      // check if new value is different from old value
      if (prev[name] !== value && !isFormChanged) {
        setIsFormChanged(true);
      }
      return {
        ...prev,
        [name]: value,
      };
    });
    setErrors((prev) => ({ ...prev, [name]: undefined }));
  };

  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          height: "90vh",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            overflowY: "auto",
            maxHeight: "80vh",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            "-ms-overflow-style": "none",
            "scrollbar-width": "none",
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            position="sticky"
          >
            <Box></Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <ReceiptLongIcon
                sx={{
                  color: "neutral.teal",
                  marginBottom: "4px",
                  marginRight: "8px",
                }}
              />
              <Typography
                variant="heading_Large"
                fontWeight={700}
                gutterBottom
                sx={headingStyle}
              >
                Modify Bill
              </Typography>
            </Box>
            <IconButton
              onClick={() => {
                resetModalState();
                onClose?.();
              }}
            >
              <CloseIcon size="small" sx={{ color: "red" }} />
            </IconButton>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "0px",
              padding: "2px",
              alignItems: "center",
            }}
          >
            {invoiceDetails?.generated_at && (
              <Typography variant="subTitle116px">
                Generated at:{" "}
                {dayjs(
                  invoiceDetails?.generated_at,
                  "YYYY-MM-DD hh:mm A",
                ).format("MMMM DD YYYY, hh:mm A")}
              </Typography>
            )}

            {uid && (
              <Typography variant="subTitle116px">
                Invoice ID: {uid}{" "}
              </Typography>
            )}
          </Box>
          {isLoading ? (
            <Skeleton variant="rectangular" width="100%" height={30} />
          ) : !invoiceDetails?.patient_info?.patient_uid ? (
            <>
              <Grid
                container
                spacing={2}
                sx={{
                  justifyContent: "space-between",
                  width: "100%",
                  mt: "4px",
                }}
              >
                {/* {"-----Search Patient Information-----"} */}
                <Grid item sm={3}>
                  <TextField
                    fullWidth
                    name="full_name"
                    onChange={handleFormChange}
                    required
                    sx={{ ...autoFocusOffWithOutBorder }}
                    value={formState.full_name}
                    placeholder="Search Patient"
                    variant="outlined"
                    error={!!errors.full_name}
                    helperText={errors.full_name}
                  />
                </Grid>

                <Grid item sm={3}>
                  <TextField
                    fullWidth
                    onChange={handleFormChange}
                    value={formState.email}
                    name="email"
                    placeholder="Email"
                    variant="outlined"
                    sx={{ ...autoFocusOffWithOutBorder }}
                    error={!!errors.email}
                    helperText={errors.email}
                    type="email"
                  />
                </Grid>

                <Grid item sm={2}>
                  <TextField
                    fullWidth
                    onChange={handleFormChange}
                    value={formState.mobile}
                    name="mobile"
                    placeholder="Mobile"
                    // type="mobile"
                    required
                    variant="outlined"
                    inputProps={{
                      maxLength: 10,
                      inputMode: "numeric",
                      pattern: "[0-9]*", // Ensure only numeric values are accepted
                    }}
                    sx={{ ...autoFocusOffWithOutBorder }}
                    error={!!errors.mobile}
                    helperText={errors.mobile}
                  />
                </Grid>

                <Grid item sm={2}>
                  <FormControl variant="outlined" sx={{ width: "100%" }}>
                    <TextField
                      fullWidth
                      required
                      onChange={handleFormChange}
                      value={formState.dob}
                      type="date"
                      name="dob"
                      sx={autoFocusOffWithOutBorder}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      // InputProps={{
                      //   startAdornment: (
                      //     <InputAdornment position="end">
                      //       <img src={calender_icon} alt="" style={{ width: 20, height: 20 }} /> {/* Your custom SVG */}
                      //     </InputAdornment>
                      //   ),
                      //   // Hide the default calendar icon
                      //   inputProps: {
                      //     style: { appearance: 'none', WebkitAppearance: 'none', MozAppearance: 'none' },  // Hide default icon
                      //   }
                      // }}
                      placeholder="DOB"
                      error={!!errors.dob}
                      helperText={errors.dob}
                      inputProps={{
                        max: new Date().toISOString().split("T")[0],
                      }}
                    />
                  </FormControl>
                </Grid>

                <Grid item sm={2}>
                  <FormControl fullWidth variant="outlined">
                    <Select
                      error={!!errors.gender}
                      required
                      fullWidth
                      sx={selectField}
                      value={formState?.gender}
                      onChange={handleFormChange}
                      name="gender"
                      displayEmpty
                      renderValue={(selected) => {
                        if (!selected) {
                          return (
                            <span style={{ color: "text.default_grey" }}>
                              Select Gender
                            </span>
                          );
                        }
                        return selected === "male"
                          ? "Male"
                          : selected === "female"
                            ? "Female"
                            : "Other";
                      }}
                    >
                      <MenuItem value="male" sx={menuItemStyle}>
                        Male
                      </MenuItem>
                      <MenuItem value="female" sx={menuItemStyle}>
                        Female
                      </MenuItem>
                      <MenuItem value="other" sx={menuItemStyle}>
                        Other
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                {isFormChanged && (
                  <Grid
                    item
                    sm={12}
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end", // move button to right side
                    }}
                  >
                    <Box sx={{ width: "100%", maxWidth: "180px" }}>
                      <Button
                        fullWidth
                        onClick={handleSavePatientInfo}
                        className="btn draw-border"
                        variant="contained"
                        id="submit"
                        sx={{
                          ...primaryBtn,
                          height: "40px", // same height as TextField
                          borderRadius: "10px", // same rounded look
                        }}
                        disabled={isLoading || isButtonDisable}
                      >
                        <Typography
                          textTransform={"capitalize"}
                          // color={"neutral.white"}
                          variant="title1_medium"
                        >
                          Save Patient Info
                        </Typography>
                      </Button>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </>
          ) : (
            <Grid
              container
              sx={{
                justifyContent: "space-between",
                width: "100%",
                mt: "10px",
              }}
            >
              <Typography variant="subTitle116px">
                Name: {formState?.full_name}
              </Typography>
              <Typography variant="subTitle116px">
                {" "}
                {invoiceDetails?.patient_info?.patient_uid &&
                  ` Patient ID:  ${invoiceDetails?.patient_info?.patient_uid}`}
              </Typography>
              {/* <Typography>Invoice ID: {uid} </Typography> */}
              <Typography variant="subTitle116px">
                Mobile: {formState?.mobile}
              </Typography>
              {formState?.age >= 0 && (
                <Typography variant="subTitle116px">
                  Age: {formState?.age === "0" ? "1" : formState?.age}{" "}
                </Typography>
              )}
              {formState?.gender && (
                <Typography
                  sx={{ textTransform: "capitalize" }}
                  variant="subTitle116px"
                >
                  Gender: {formState?.gender}
                </Typography>
              )}
            </Grid>
          )}

          <Grid item xs={12}>
            <TableContainer
              sx={{
                mt: 2,
                width: "100%",
                overflowY: "scroll",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                "-ms-overflow-style": "none",
                "scrollbar-width": "none",
              }}
            >
              <Table
                sx={{
                  width: "100%",
                  overflowY: "scroll",
                  "&::-webkit-scrollbar": {
                    display: "none",
                  },
                  "-ms-overflow-style": "none",
                  "scrollbar-width": "none",
                }}
              >
                <TableHead stickyHeader>
                  <TableRow sx={{ ...drTableGreen, textAlign: "center" }}>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        borderTopLeftRadius: "20px",
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      ID
                    </TableCell>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        //  paddingX:"4px",
                        textAlign: "center",
                        width: "200px",
                      }}
                    >
                      Name
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        width: "150px",
                        paddingRight: "30px",
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Quantity
                    </TableCell>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Batch
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Return
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Total Stock
                    </TableCell>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Pack
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Unit MRP
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      MRP
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Discount
                    </TableCell>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      GST
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                        borderTopRightRadius: showBtn ? "20px" : " ",
                      }}
                    >
                      Amount
                    </TableCell>

                    {!showBtn && (
                      <TableCell
                        sx={{
                          p: "4px",
                          textAlign: "center",
                          borderTopRightRadius: "20px",
                        }}
                      >
                        <IconButton
                          onClick={handleAddRow}
                          sx={{
                            ...orangeButton,
                            marginLeft: "7px",
                            marginY: "2px",
                          }}
                        >
                          <AddIcon
                            sx={{
                              color: "neutral.white",
                              width: "30px",
                              height: "32px",
                              padding: "0px",
                            }}
                          />
                        </IconButton>
                      </TableCell>
                    )}
                  </TableRow>
                </TableHead>

                {isLoading ? (
                  <TableRow>
                    <TableCell colSpan={12}>
                      <Skeleton
                        variant="rectangular"
                        width="100%"
                        height={300}
                        sx={{ backgroundColor: "lightgray", marginTop: "10px" }}
                      />
                    </TableCell>
                  </TableRow>
                ) : (
                  <TableBody>
                    {medicines?.length > 0 &&
                      medicines?.map((medicine, index) => (
                        <TableRow
                          sx={{
                            ...tableRowLab,
                            // ...(medicine.returned && {
                            //   pointerEvents: "none", // Disables all interactions
                            //   opacity: 0.6, // Visually indicate it's disabled
                            //   backgroundColor: "#f0f0f0", // Light gray background for disabled rows
                            // }),
                            // "&:hover": {
                            //   transform: "scale(1.001)",
                            //   boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                            //   borderRadius: "20px !important",
                            // },
                          }}
                        >
                          <TableCell sx={tableCellLab}>
                            <Typography
                              variant="body_Grey1"
                              color={"text.grey"}
                            >
                              {index + 1}
                            </Typography>
                          </TableCell>

                          <TableCell sx={tableCellLab}>
                            <Autocomplete
                              options={filteredMedicines}
                              freeSolo
                              clearOnEscape={false}
                              // clearIcon={null}
                              open={openMedicineList === index}
                              onOpen={() => setOpenMedicines(index)}
                              onClose={() => setOpenMedicines(false)}
                              id={`name-${index}`}
                              inputValue={
                                medicine?.name !== null ? medicine?.name : ""
                              }
                              onInputChange={(e, value) => {
                                handleChange(index, "name", value, e);
                              }}
                              disabled={showBtn}
                              onChange={(e, value) => {
                                // console.log(value);
                                if (!value) {
                                  setMedicines((prevMedicines) =>
                                    prevMedicines.map((medicine, idx) =>
                                      idx === index
                                        ? {
                                            id: "",
                                            name: "",
                                            quantity: "",
                                            batchId: null,
                                            batch: "",
                                            batchArray: [],
                                            returned: false,
                                            stock: "",
                                            packing: "",
                                            unitMrp: null,
                                            mrp: null,
                                            discount: null,
                                            gst: null,
                                            amount: null,
                                          }
                                        : medicine,
                                    ),
                                  );

                                  setSelectedMedicine(null);
                                } else if (value && medicine?.id) {
                                  handleChange(index, "id", value[0]);
                                  handlePresence(index, value);
                                  setSelectedMedicine({
                                    name: value[1],
                                    id: value[0],
                                  });
                                  setMedicines((prevMedicines) =>
                                    prevMedicines?.map((medicine, idx) =>
                                      idx === index
                                        ? {
                                            ...medicine,
                                            quantity: "",
                                            batchId: null,
                                            batch: "",
                                            batchArray: [],
                                            returned: false,
                                            stock: "",
                                            packing: "",
                                            unitMrp: null,
                                            mrp: null,
                                            discount: null,
                                            gst: null,
                                            amount: null,
                                          }
                                        : medicine,
                                    ),
                                  );
                                  setTimeout(() => {
                                    document
                                      .getElementById(`quantity-${index}`)
                                      .focus();
                                  }, 0);
                                } else {
                                  // console.log(value, 'value inside autocomplete ')
                                  handleChange(index, "id", value[0]);
                                  handlePresence(index, value);
                                  setSelectedMedicine({
                                    name: value[1],
                                    id: value[0],
                                  });

                                  setTimeout(() => {
                                    document
                                      .getElementById(`quantity-${index}`)
                                      .focus();
                                  }, 0);
                                }
                              }}
                              sx={{ ...textfieldText }}
                              PopperComponent={(props) => (
                                <Grid item lg={8}>
                                  <Popper
                                    {...props}
                                    placement="bottom-start"
                                    style={menuItemStyle}
                                    modifiers={[
                                      {
                                        name: "preventOverflow",
                                        options: {
                                          boundary: "block",
                                        },
                                      },
                                    ]}
                                  >
                                    <div
                                      style={{
                                        maxHeight: 300,
                                        overflowY: "auto",
                                        scrollbarWidth: "none",
                                        maxWidth: "320px",
                                        minWidth: "310px",
                                      }}
                                    >
                                      {props.children}
                                    </div>
                                  </Popper>
                                </Grid>
                              )}
                              getOptionLabel={(option) => option[1]}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  onChange={handleSearch}
                                  value={searchTerm}
                                  placeholder="Medicine"
                                  onKeyDown={(e) =>
                                    handleKeyDown(e, index, "name")
                                  }
                                  // sx={{
                                  //   "& .MuiInputBase-input": {
                                  //     color: `${medicine.returned ? "#ed5564" : 'black'}`
                                  //   },
                                  // }}
                                />
                              )}
                              renderOption={(props, option, { index }) => (
                                // <MenuItem
                                //   sx={{
                                //     ...menuItemStyle,
                                //     "&:hover": {
                                //       backgroundColor: "#f58633 !important",
                                //       color: "white !important",
                                //     },
                                //     ...(index === 0 && {
                                //       backgroundColor: "#f58633 !important",
                                //       color: "white !important",
                                //     }),
                                //   }}
                                //   {...props}
                                //   key={option[0]}
                                // >
                                //   {option[1]}
                                // </MenuItem>
                                <MenuItem
                                  sx={{
                                    ...menuItemStyle,
                                    "&:hover": {
                                      backgroundColor: "#9fd8d8ff !important",
                                      // borderRadius:"20%",
                                      borderRadius: "16px",

                                      color: "black !important",
                                    },
                                    ...(index === highlightedIndexMedicine && {
                                      backgroundColor: "#9fd8d8ff !important",
                                      color: "black !important",
                                      borderRadius: "16px",
                                    }),
                                  }}
                                  {...props}
                                  key={option[0]}
                                >
                                  {option[1]}
                                </MenuItem>
                              )}
                            />
                          </TableCell>

                          <TableCell sx={tableCellLab}>
                            <TextField
                              fullWidth
                              placeholder="Quantity"
                              variant="outlined"
                              type="number"
                              // error={
                              //   medicine?.quantity ? medicine?.quantity <= 0 : false
                              // }
                              // helperText={
                              //   medicine?.quantity <= 0 && medicine?.quantity
                              //     ? "Quantity must be more than zero"
                              //     : null
                              // }
                              id={`quantity-${index}`}
                              sx={{
                                ...textfieldText,
                              }}
                              disabled={showBtn}
                              value={medicine?.quantity}
                              onKeyDown={(e) =>
                                handleKeyDown(e, index, "quantity")
                              }
                              onChange={(e) => {
                                if (e.target.value < 0) {
                                  return;
                                }
                                handleChange(index, "quantity", e.target.value);
                                handleQuantityChange(
                                  index,
                                  "quantity",
                                  e.target.value,
                                );
                              }}
                              inputProps={{
                                min: 0,
                              }}
                            />
                          </TableCell>

                          <TableCell sx={{ ...tableCellLab, width: "100px" }}>
                            <FormControl fullWidth variant="outlined">
                              <Select
                                // sx={selectField}
                                sx={{
                                  ...textfieldTextBlueBorderPharmacy,
                                  borderRadius: "10px",
                                  backgroundColor: "white",
                                  "& .MuiSelect-select": {
                                    padding: "9px", // Custom padding for select dropdown
                                    minWidth: "120px",
                                  },
                                  ...(medicine?.batchError && {
                                    "& .MuiOutlinedInput-notchedOutline": {
                                      borderColor: "#ed5564 !important",
                                      borderWidth: "1.5px",
                                    },
                                    borderColor: "#ed5564 !important",
                                  }),
                                }}
                                placeholder="Batch"
                                fullWidth
                                value={medicines[index]?.batchId || ""}
                                //onChange={(e) => {
                                //   handleQuantityChange(
                                //     index,
                                //     "batchId",
                                //     e.target.value
                                //   );
                                // }}
                                disabled={showBtn}
                                onChange={(e) => {
                                  handleChange(
                                    index,
                                    "batchId",
                                    e.target.value,
                                  );
                                  handleQuantityChange(
                                    index,
                                    "batchId",
                                    e.target.value,
                                  );
                                }}
                                renderValue={(selected) => {
                                  // Find the selected batch object by ID
                                  const selectedBatch = medicines[
                                    index
                                  ]?.batchArray?.find(
                                    (batch) => batch.id === selected,
                                  );
                                  return (
                                    selectedBatch?.batch_no || "Select Batch"
                                  );
                                }}
                              >
                                {medicines[index]?.batchArray?.map((batch) => (
                                  <MenuItem key={batch.id} value={batch.id}>
                                    <Box display="flex" flexDirection="column">
                                      <Typography
                                        fontSize="14px"
                                        fontWeight={400}
                                      >
                                        {batch?.batch_no}
                                      </Typography>

                                      <Typography
                                        fontSize="12px"
                                        color="text.secondary"
                                      >
                                        {`${batch?.stock_left}  |  `}
                                        {expiryMedicineFormate(
                                          batch?.expiry_date,
                                        )}
                                      </Typography>
                                    </Box>
                                  </MenuItem>
                                ))}
                              </Select>
                              {/* Render the batch stock and expiry date */}

                              {!medicine?.batchId &&
                              medicine?.is_consumable === false ? (
                                <FormHelperText>
                                  Please select a batch.
                                </FormHelperText>
                              ) : (
                                ""
                              )}
                              <Box
                                justifyContent={"space-between"}
                                display={"flex"}
                                paddingX={"2px"}
                              >
                                <Typography
                                  fontSize={"12px"}
                                  color={` ${
                                    medicine?.quantity >
                                      medicines[index]?.batch?.stock_left ||
                                    isExpiredDate(medicine?.expiry_date)
                                      ? "#ed5564"
                                      : medicine?.batchError
                                        ? "#ed5564"
                                        : "text.grey"
                                  } `}
                                >
                                  {medicine?.batchError
                                    ? "0"
                                    : medicines[index]?.batch?.stock_left}
                                </Typography>
                                <Typography fontSize={"12px"}>
                                  {expiryMedicineFormate(medicine?.expiry_date)}
                                </Typography>
                              </Box>
                            </FormControl>
                          </TableCell>

                          <TableCell sx={tableCellLab}>
                            {!medicine?.invoice_id ? (
                              <Checkbox
                                id={`return-${index}`}
                                checked={medicine?.returned}
                                onKeyDown={(e) =>
                                  handleKeyDown(e, index, "return")
                                }
                                onChange={() => {
                                  if (!medicine?.id) return; // ✅ optional: jab tak medicine select na ho, ignore
                                  handleReturnChange(index);
                                }}
                                disabled={!medicine?.id}
                                sx={{ height: "10px", width: "10px" }}
                              />
                            ) : (
                              <Checkbox
                                id={`return-${index}`}
                                checked={medicine?.returned}
                                readOnly={true}
                                disabled={true}
                                onKeyDown={(e) =>
                                  handleKeyDown(e, index, "return")
                                }
                                onChange={() => {
                                  if (!medicine?.id) return; // ✅ optional: jab tak medicine select na ho, ignore
                                  handleReturnChange(index);
                                }}
                                sx={{ height: "10px", width: "10px" }}
                              />
                            )}
                          </TableCell>
                          <TableCell sx={tableCellLab}>
                            <Typography
                              variant="body_Grey1"
                              color={` ${
                                medicine?.quantity > medicine?.stock
                                  ? "#ed5564"
                                  : "text.grey"
                              } `}
                            >
                              {medicine?.stock || 0}
                            </Typography>
                          </TableCell>

                          <TableCell sx={tableCellLab}>
                            <Typography
                              variant="body_Grey1"
                              color={"text.grey"}
                            >
                              {medicine?.packing}
                            </Typography>
                          </TableCell>

                          <TableCell sx={tableCellLab}>
                            {medicine.returned ? (
                              <Typography
                                variant="body_Grey1"
                                color={"#ed5564"}
                              >
                                {" "}
                                {isNaN(+medicine?.unitMrp)
                                  ? ""
                                  : medicine?.unitMrp}{" "}
                              </Typography>
                            ) : (
                              <Typography
                                variant="body_Grey1"
                                color={"text.grey"}
                              >
                                {isNaN(+medicine?.unitMrp)
                                  ? ""
                                  : medicine?.unitMrp}
                              </Typography>
                            )}
                          </TableCell>

                          <TableCell sx={tableCellLab}>
                            {medicine.returned ? (
                              <Typography
                                variant="body_Grey1"
                                color={"#ed5564"}
                              >
                                {" "}
                                {medicine?.mrp}{" "}
                              </Typography>
                            ) : (
                              <Typography
                                variant="body_Grey1"
                                color={"text.grey"}
                              >
                                {medicine.mrp}
                              </Typography>
                            )}
                          </TableCell>

                          <TableCell sx={tableCellLab}>
                            {medicine.returned ? (
                              <Typography
                                variant="body_Grey1"
                                color={"#ed5564"}
                              >
                                {" "}
                                {specialDiscountPct ? `${specialDiscountPct}%` : medicine?.discount}{" "}
                              </Typography>
                            ) : (
                              <Typography
                                variant="body_Grey1"
                                color={"text.grey"}
                              >
                                {specialDiscountPct ? `${specialDiscountPct}%` : medicine?.discount}
                              </Typography>
                            )}
                          </TableCell>

                          <TableCell sx={tableCellLab}>
                            <Typography
                              variant="body_Grey1"
                              color={"text.grey"}
                            >
                              {medicine?.gst}
                            </Typography>
                          </TableCell>

                          <TableCell sx={tableCellLab}>
                            {medicine?.returned ? (
                              <Typography
                                variant="body_Grey1"
                                color={"#ed5564"}
                              >
                                {" "}
                                {specialDiscountPct
                                  ? ((parseFloat(medicine?.unitMrp) || 0) * (parseFloat(medicine?.quantity) || 0) * (1 - parseFloat(specialDiscountPct) / 100)).toFixed(2)
                                  : medicine?.amount}{" "}
                              </Typography>
                            ) : (
                              <Typography
                                variant="body_Grey1"
                                color={"text.grey"}
                              >
                                {specialDiscountPct
                                  ? ((parseFloat(medicine?.unitMrp) || 0) * (parseFloat(medicine?.quantity) || 0) * (1 - parseFloat(specialDiscountPct) / 100)).toFixed(2)
                                  : medicine?.amount}
                              </Typography>
                            )}
                          </TableCell>

                          {!showBtn && (
                            <TableCell sx={tableCellLab}>
                              <IconButton
                                sx={{ marginLeft: "8px", marginBottom: "7px" }}
                                onClick={() => handleRemoveRow(index)}
                              >
                                <CloseIcon
                                  sx={{
                                    ...xBtn,
                                    width: "26px",
                                    height: "26px",
                                  }}
                                />
                              </IconButton>

                              {medicine?.id && (
                                <IconButton
                                  onClick={() => {
                                    setSelectedMedicineForEdit(medicine?.id);
                                    setEditMedicine(true);
                                  }}
                                >
                                  <Edit
                                    sx={{
                                      ...xBtn,
                                      width: "23px",
                                      height: "23px",
                                      borderRadius: "50%",
                                      p: 0.4,
                                      color: "neutral.white",
                                      backgroundColor: "neutral.teal",
                                      "&:hover": {
                                        backgroundColor: "neutral.teal",
                                      },
                                      marginBottom: "7px",
                                    }}
                                  />
                                </IconButton>
                              )}
                            </TableCell>
                          )}
                        </TableRow>
                      ))}
                  </TableBody>
                )}
              </Table>
            </TableContainer>
            {showBtn && (
              <Box
                sx={{
                  ...tableRowLab,
                  borderBottomLeftRadius: "20px",
                  borderBottomRightRadius: "20px",
                  borderTopLeftRadius: "0px",
                  borderTopRightRadius: "0px",
                  justifyContent: "space-between",
                  display: "flex",
                  height: "60px",
                  alignItems: "center",
                  padding: "3px",
                  paddingX: "40px",
                }}
              >
                <Box
                  sx={{
                    justifyContent: "space-between",
                    display: "flex",
                    height: "60px",
                    alignItems: "center",
                  }}
                  columnGap={"10px"}
                >
                  {!showButton && (
                    <>
                      <Typography variant="h6">Selected : </Typography>
                      <Typography variant="h6">{select}</Typography>
                    </>
                  )}
                </Box>

                <Box
                  sx={{
                    justifyContent: "space-between",
                    display: "flex",
                    // min-height: "60px",
                    minHeight: "60px",
                    height: "min-content",
                    alignItems: "center",
                  }}
                  columnGap={"10px"}
                >
                  <Box>
                    <Typography variant="h6" fontSize={18}>
                      Total:
                    </Typography>
                    {/* {showBtn && (
                      <Typography variant="p" fontFamily={"sans-serif"}>
                        Round-Off:
                      </Typography>
                    )} */}
                  </Box>

                  <Box>
                    <Typography variant="h6" fontSize={18}>
                      {" "}
                      {isNaN(total) ? 0 : total?.toFixed(2)}
                      {/* : invoiceDetails?.grand_total?.toFixed(2)} */}
                    </Typography>

                    {/* <Typography variant="p" fontFamily={"sans-serif"}>
                      {Math.abs(
                        invoiceDetails?.grand_total -
                          invoiceDetails?.invoice_items
                            ?.reduce(
                              (total, item) => total + (item?.amount || 0),
                              0,
                            )
                            .toFixed(2),
                      ).toFixed(2)}
                    </Typography> */}
                  </Box>
                </Box>
              </Box>
            )}
          </Grid>
        </Box>

        {/* Payment + Save*/}
        <Paper
          elevation={6}
          sx={{
            position: "sticky",
            bottom: 0,
            zIndex: 20,
            mt: 1,
            minHeight: "max-content",
            borderRadius: "16px",
            overflow: "hidden",
            border: "1px solid rgba(0,0,0,0.08)",
            backdropFilter: "blur(6px)",
          }}
        >
          {/* Top row */}
          <Box
            sx={{
              px: 2,
              py: 1.5,
              background:
                "linear-gradient(180deg, rgba(0,103,255,0.06), rgba(0,0,0,0))",
            }}
          >
            <Stack
                spacing={2}
              alignItems={{ xs: "start", }}
              justifyContent="space-between"
              direction={"column"}
            >
              <Stack
                direction="row"
                // spacing={2}
                gap={2}
                alignItems="center"
                flexWrap="wrap"
                sx={{ flex: 1 }}
              
              >
                {/* Row 1 */}
                <FormControl sx={{ minWidth: 200 }} variant="outlined">
                  <InputLabel shrink id="payment-mode-label-0">
                    Payment Mode
                  </InputLabel>
                  <Select
                    disabled={showBtn}
                    labelId="payment-mode-label-0"
                    label="Payment Mode"
                    value={
                      invoicePaymentsAttributes?.[0]?.payment_mode || "UPI"
                    }
                    onChange={(e) =>
                      updatePaymentRow(0, "payment_mode", e.target.value)
                    }
                    sx={{
                      ...selectField,
                      height: 44,
                      backgroundColor: "white",
                    }}
                  >
                    {getAvailablePaymentModes(0).map((m) => (
                      <MenuItem
                        key={m.value}
                        value={m.value}
                        sx={menuItemStyle}
                      >
                        {m.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <TextField
                  InputLabelProps={{ shrink: true }}
                  disabled={showBtn}
                  label="Net Payable"
                  type="text"
                  inputProps={{ inputMode: "decimal" }}
                  value={invoicePaymentsAttributes?.[0]?.amount ?? ""}
                  onChange={(e) => handlePrimaryAmountChange(e.target.value)}
                  onBlur={handlePrimaryAmountBlur}
                  shrink={true}
                  sx={{
                    ...textfieldTextPrep,
                    width: 220,
                    "& .MuiInputBase-root": {
                      height: 44,
                      backgroundColor: "white",
                    },
                  }}
                />

                {/* Row 2 appears automatically */}
                {invoicePaymentsAttributes.length === 2 && (
                  <>
                    <FormControl sx={{ minWidth: 200 }} variant="outlined">
                      <InputLabel shrink id="payment-mode-label-1">
                        Payment Mode 2
                      </InputLabel>
                      <Select
                        disabled={showBtn}
                        labelId="payment-mode-label-1"
                        label="Mode 2"
                        value={
                          invoicePaymentsAttributes?.[1]?.payment_mode || "Cash"
                        }
                        onChange={(e) =>
                          updatePaymentRow(1, "payment_mode", e.target.value)
                        }
                        sx={{
                          ...selectField,
                          height: 44,
                          backgroundColor: "white",
                        }}
                      >
                        {getAvailablePaymentModes(1).map((m) => (
                          <MenuItem
                            key={m.value}
                            value={m.value}
                            sx={menuItemStyle}
                          >
                            {m.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <TextField
                      label="Remaining"
                      value={invoicePaymentsAttributes?.[1]?.amount ?? ""}
                      inputProps={{ readOnly: true }}
                      sx={{
                        ...textfieldTextPrep,
                        width: 220,
                        "& .MuiInputBase-root": {
                          height: 44,
                          backgroundColor: "#f7f7f7",
                        },
                      }}
                    />
                  </>
                )}
                 {/* Special Discount fields */}

                   <TextField
                  label="Special Discount %"
                  type="number"
                  value={specialDiscountPct}
                  onChange={(e) => handleSpecialDiscountPct(e.target.value)}
                  inputProps={{ min: 0, max: 100, step: 0.01 }}
                  sx={{
                    ...textfieldTextPrep,
                    width: 180,
                    "& .MuiInputBase-root": { height: 44, backgroundColor: "white" },
                  }}
                />
                <TextField
                  label="Special Discount ₹"
                  type="number"
                  value={specialDiscountINR}
                  onChange={(e) => handleSpecialDiscountINR(e.target.value)}
                  inputProps={{ min: 0, step: 0.01 }}
                  sx={{
                    ...textfieldTextPrep,
                    width: 180,
                    "& .MuiInputBase-root": { height: 44, backgroundColor: "white" },
                  }}
                />
              </Stack>

             
             
              {/* Summary */}
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent={{ xs: "flex-start", md: "flex-end" }}
                flexWrap="wrap"
              >
                <Chip
                  label={
                    <Typography fontWeight={800}>
                      Taxable Amt: {Number(billSummary.taxableTotal || 0).toFixed(2)}
                    </Typography>
                  }
                />
                <Chip
                  label={
                    <Typography fontWeight={800}>
                      GST: {Number(billSummary.totalGst || 0).toFixed(2)}
                    </Typography>
                  }
                />
                <Chip
                  label={
                    <Typography fontWeight={800}>
                      Discount: {Number(billSummary.discount || 0).toFixed(2)}
                    </Typography>
                  }
                />
                {roundOff !== null && roundOff !== undefined && (
                  <Chip
                    label={
                      <Typography fontWeight={800}>
                        Round Off: {roundOff}
                      </Typography>
                    }
                  />
                )}
                <Chip
                  sx={{ backgroundColor: "#e8f5e9" }}
                  label={
                    <Typography fontWeight={800} color="green">
                      Net Payable: {Number(billSummary.netPayable || 0).toFixed(2)}
                    </Typography>
                  }
                />
                {/* <Chip
                          label={
                            <Typography fontWeight={800}>
                              Paid: {paidTotal.toFixed(2)}
                            </Typography>
                          }
                        />
                        <Chip
                          variant="outlined"
                          sx={{
                            borderColor:
                              Number(remainingTotal) === 0
                                ? "rgba(0,0,0,0.12)"
                                : "rgba(237, 85, 100, 0.6)",
                          }}
                          label={
                            <Typography fontWeight={800}>
                              Remaining: {remainingTotal}
                            </Typography>
                          }
                        /> */}
              </Stack>
            </Stack>

            {errors.split_payment && (
              <Typography color="error" fontSize="12px" mt={1}>
                {errors.split_payment}
              </Typography>
            )}
          </Box>

          {/* Split payment rows */}
          {/* <Collapse in={paymentSplitEnabled} timeout={200} s>
                    <Divider />
                    <Box sx={{ px: 2, py: 1.5 }}>
                      <Stack spacing={1.25}>
                        {invoicePaymentsAttributes.map((row, index) => (
                          <Stack
                            key={index}
                            direction={{ xs: "column", sm: "row" }}
                            spacing={1.25}
                            alignItems={{ xs: "stretch", sm: "center" }}
                          >
                            <FormControl sx={{ minWidth: 200 }} variant="outlined">
                              <InputLabel shrink id={`split-mode-${index}`}>
                                Mode
                              </InputLabel>
        
                              <Select
                                labelId={`split-mode-${index}`}
                                label="Mode"
                                value={row.payment_mode}
                                onChange={(e) =>
                                  updatePaymentRow(
                                    index,
                                    "payment_mode",
                                    e.target.value,
                                  )
                                }
                                sx={{
                                  ...selectField,
                                  height: 44,
                                  backgroundColor: "white",
                                }}
                              >
                                {paymentModes.map((m) => (
                                  <MenuItem
                                    key={m.value}
                                    value={m.value}
                                    sx={menuItemStyle}
                                  >
                                    {m.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
        
                            <TextField
                              label="Amount"
                              type="number"
                              value={row.amount}
                              onChange={(e) => {
                                const v = e.target.value;
                                if (+v < 0) return;
                                updatePaymentRow(index, "amount", v);
                              }}
                              sx={{
                                ...textfieldTextPrep,
                                width: { xs: "100%", sm: 260 },
                                "& .MuiInputBase-root": {
                                  height: 44,
                                  backgroundColor: "white",
                                },
                              }}
                            />
                          </Stack>
                        ))}
        
                        {errors.split_payment && (
                          <Typography color="error" fontSize="12px">
                            {errors.split_payment}
                          </Typography>
                        )}
                      </Stack>
                    </Box>
                  </Collapse> */}

          {/* Bottom action row */}
          <Divider />

          <Box
            sx={{
              px: 2,
              py: 1.5,
              backgroundColor: "rgba(0,0,0,0.015)",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 2,
              flexWrap: { xs: "wrap", md: "nowrap" },
            }}
          >
            {/* LEFT ACTIONS */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                flexWrap: "wrap",
              }}
            >
              {!showBtn && (
                <Button
                  variant="contained"
                  sx={{
                    ...primaryBtn,
                    height: 44,
                    minWidth: 195,
                  }}
                  disabled={isButtonDisable}
                  onClick={() => setDeleteModal(true)}
                >
                  Refund & Cancel
                </Button>
              )}

              <Button
                variant="contained"
                sx={{
                  ...primaryBtn,
                  height: 44,
                  minWidth: 140,
                }}
                onClick={rePrint}
                // disabled={isButtonDisable}
                disabled={isLoading || isButtonDisable || isPriceFetching}
              >
                Reprint
              </Button>
            </Box>

            {/* RIGHT ACTION */}
            {!showBtn && (
              <Box sx={{ marginLeft: "auto" }}>
                <Button
                  onClick={saveAndPrint}
                  variant="contained"
                  id="submit"
                  sx={{
                    ...primaryBtnTeal,
                    height: 44,
                    minWidth: 195,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  // disabled={isLoading || isButtonDisable}
                  disabled={
                    isLoading ||
                    isButtonDisable ||
                    isPriceFetching ||
                    (allowBatchStockZero &&
                      medicines.some((m) => m?.batchError))
                  }
                >
                  Save & Print
                </Button>
              </Box>
            )}
          </Box>
        </Paper>
      </Box>

      <div style={{ display: "none" }}>
        <PharmacyInvoice props={printInvoiceData} ref={printRef} />
      </div>

      <CustomModal
        customStyles={{ border: "none", minWidth: "85%", maxWidth: "90%" }}
        open={editMedicine}
        onClose={() => setEditMedicine(false)}
      >
        <EditMedicineBatchShort
          onClose={() => setEditMedicine(false)}
          id={selectedMedicineForEdit}
        />
      </CustomModal>

      <Modal
        open={deleteModal}
        onClose={() => setDeleteModal(false)}
        sx={{
          position: "absolute",
          top: "25%",
          width: "450px",
          margin: "auto",
          borderRadius: "20px",
        }}
      >
        <Box
          sx={{
            mt: 2,
            bgcolor: "background.paper",
            borderRadius: 3.6,
            boxShadow: 24,
            p: 4.5,
            "&:focus": {
              outline: "none",
            },
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography textAlign={"center"}>Are you sure?</Typography>
            <Typography textAlign={"center"}>
              You want to refund this invoice ?
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "flex",
              gap: "25px",
              width: "max-content",
              margin: "auto",
              marginTop: "40px",
            }}
          >
            <Button
              sx={{
                backgroundColor: "#FF392B",
                color: "white",
                border: "",
                width: "150px",
                borderRadius: "5px",
                fontSize: "12px",
                textTransform: "capitalize",
                "&:hover": {
                  backgroundColor: "red",
                },
              }}
              disabled={isLoading || isButtonDisable || isPriceFetching}
              onClick={() => refundAndCancel()}
            >
              Refund & cancel
            </Button>
            <Button
              onClick={() => setDeleteModal(false)}
              sx={{
                backgroundColor: "white",
                color: "black",
                border: "2px solid #FF392B",
                width: "150px",
                borderRadius: "5px",
                fontSize: "12px",
                textTransform: "capitalize",
              }}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default PastBillPharmacyByInvoice;
